/* eslint-disable */
require('./addWorkOrder')
require('./blacklist')
require('./card')
require('./chrome')
require('./close')
require('./cut')
require('./deletBtn')
require('./dialogue')
require('./editworkorder')
require('./end')
require('./expand')
require('./fold')
require('./folder')
require('./guiji')
require('./handDown')
require('./history')
require('./historyClose')
require('./image')
require('./import')
require('./indent')
require('./maximize')
require('./meh')
require('./message')
require('./minimize')
require('./msgWorkorder')
require('./out')
require('./outdent')
require('./play')
require('./priority')
require('./reloadBtn')
require('./remark')
require('./repository')
require('./setting')
require('./solevBtn')
require('./transfer')
require('./video')
require('./visitor')
require('./windows')
require('./workorder')
require('./workorderAdd')
require('./workorderCancel')
require('./workorderFinished')
require('./workorderReload')
require('./workorderTransfer')
